import { BottomSheetHeader } from '@ui-kit/components/BottomSheet/components/Header'
import ModalSelector from '@ui-kit/components/ModalSelector'

import { IMAGE } from './assets/images/index.native'
import Alert from './components/Alert'
import AppDownloadButtons from './components/AppDownloadButtons'
import Avatar from './components/Avatar'
import Badge from './components/Badge'
import TopBar from './components/Bars/TopBar'
import BottomSheetFooter from './components/BottomSheet/components/Footer'
import Button from './components/Button'
import ButtonIcon from './components/ButtonIcon'
import Chip from './components/Chip'
import CircleButton from './components/CircleButton'
import CircularProgress from './components/CircularProgress'
import Flag from './components/Flag'
import Icon from './components/Icon'
import InfoNote from './components/InfoNote'
import InlineNotification from './components/InlineNotification'
import LanguageSwitcher from './components/LanguageSwitcher'
import Progress from './components/Progress'
import Quote from './components/Quote'
import Spinner from './components/Spinner'
import Stepper from './components/Stepper'
import TabBar from './components/TabBar'
import Table from './components/Table'
import Tag from './components/Tag'
import Wave from './components/Wave'
import CallToActionCard from './components/cards/CallToActionCard'
import Card from './components/cards/Card'
import CardHighlight from './components/cards/CardHighlight'
import CardInfo from './components/cards/CardInfo'
import Autocomplete from './components/formComponents/Autocomplete'
import * as autocompleteHooks from './components/formComponents/Autocomplete/hooks'
import CodeInput from './components/formComponents/CodeInput'
import MultiSelect from './components/formComponents/MultiSelect'
import PhoneNumberInput from './components/formComponents/PhoneNumberInput'
import RadioCardSet from './components/formComponents/RadioCardSet'
import Select from './components/formComponents/Select'
import SelectionButtonSet from './components/formComponents/SelectionButtonSet'
import SelectionButton from './components/formComponents/SelectionButtonSet/SelectionButton/index.native'
import Switch from './components/formComponents/Switch'
import SwitchCard from './components/formComponents/SwitchCard'
import TextField from './components/formComponents/TextField'
import Box from './components/layoutComponents/Box/index.native'
import Columns from './components/layoutComponents/Columns'
import Section from './components/layoutComponents/Section'
import Separator from './components/layoutComponents/Separator'
import Spacer from './components/layoutComponents/Spacer'
import Stack from './components/layoutComponents/Stack'
import TextSeparator from './components/layoutComponents/TextSeparator'
import WaveSeparator from './components/layoutComponents/WaveSeparator'
import AccordionList from './components/listComponents/AccordionList'
import InformationList from './components/listComponents/InformationList'
import LineList from './components/listComponents/LineList'
import ListItem from './components/listComponents/ListItem'
import * as constants from './constants'
import * as typography from './core/typography'

export type { ButtonType } from './components/Button/types'
export type { IconBgShape, NativeProps as IconProps } from './components/Icon/types'
export type { TableData } from './components/Table/types'
export type { WaveShape } from './components/Wave/types'
export type { AddressDetail } from './components/formComponents/Autocomplete/hooks'
export type {
  MultiSelectProps,
  MultiSelectOption,
  MultiSelectOptionValue,
} from './components/formComponents/MultiSelect/types'
export type {
  RadioCardOptionNative as RadioCardOption,
  NativeProps as RadioCardSetProps,
} from './components/formComponents/RadioCardSet/types'
export type {
  Option as SelectOption,
  NativeProps as SelectProps,
} from './components/formComponents/Select/types'
export type {
  Option as SelectionButtonSetOption,
  NativeProps as SelectionButtonSetProps,
} from './components/formComponents/SelectionButtonSet/types'
export type { AccordionItem } from './components/listComponents/AccordionList/types'
export type { DataItem, LineListItem } from './components/listComponents/LineList/types'
export type { NativeListItemProps as ListItemProps } from './components/listComponents/ListItem/types'
export type { BaseTextProps, HeadingProps, RegularTextProps } from './core/typography'
export * from './styles/colors'
export * from './styles/margin'
export * from './styles/padding'
export * from './types'

const UiKit = {
  IMAGE,
  ...autocompleteHooks,
  ...constants,
  ...typography,
  AccordionList,
  Alert,
  AppDownloadButtons,
  Autocomplete,
  Avatar,
  Badge,
  BottomSheetFooter,
  BottomSheetHeader,
  Box,
  Button,
  ButtonIcon,
  CallToActionCard,
  Card,
  CardInfo,
  CardHighlight,
  Chip,
  CircleButton,
  CodeInput,
  Columns,
  Flag,
  Icon,
  InfoNote,
  InformationList,
  InlineNotification,
  ModalSelector,
  ListItem,
  Progress,
  Quote,
  PhoneNumberInput,
  RadioCardSet,
  Section,
  Separator,
  LineList,
  Select,
  SelectionButton,
  SelectionButtonSet,
  Spacer,
  Spinner,
  Stack,
  Switch,
  SwitchCard,
  Tag,
  TabBar,
  Table,
  TopBar,
  TextField,
  TextSeparator,
  MultiSelect,
  Wave,
  WaveSeparator,
  LanguageSwitcher,
  Stepper,
  CircularProgress,
}

export default UiKit
